import { RECEIVE_DRAFT_MESSAGE_FILES, RECEIVE_MESSAGE, RECEIVE_MESSAGES, REQUEST_MESSAGES } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        shouldFetch: true,
        isFetching: false,
        items: [],
        draftMessageFiles: {},
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_MESSAGES:
            return { ...state, shouldFetch: false, isFetching: true }

        case RECEIVE_MESSAGES: {
            const items = data?.items || []

            return {
                ...state,
                ...data,
                items,
                isFetching: false,
            }
        }

        case RECEIVE_MESSAGE: {
            return { ...state, items: [...state.items, data] }
        }

        case RECEIVE_DRAFT_MESSAGE_FILES: {
            const { draftMessageId, files } = data

            const currentDraftMessageFiles = state.draftMessageFiles
            const newDraftMessageFiles = { ...currentDraftMessageFiles, [draftMessageId]: files }

            return { ...state, draftMessageFiles: newDraftMessageFiles }
        }

        default:
            return state
    }
}
